export default "__VITE_ASSET__$AKS74jf__"